<button class="button " 
  (click)="clickHandler()" 
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  [disabled]="disabled" 
  [ngClass]="[buttonType, iconType ? 'button-icon': '' ]"
  [ngStyle]="buttonStyle">
  <i *ngIf="iconType" class="pi " [ngClass]="iconType"></i>
  <pre>{{buttonText}}</pre>
</button>